<template>

<v-dialog v-model="dialog" width="600px">
  <v-card>
    <p class=".title ma-2">Add a distance to {{hsaf.huis_code }} </p>
    <v-form ref="addHsaf" v-model="addHsafValid">
     <v-row no-gutters>
      <v-col class="mx-2" cols="6">
       <v-select v-model="hsaf.afst_nr" required :items="afst_nrKeuzes" item-value="afst_nr" item-text="afsttaal_oms" label="Distance to" :rules="afst_nrRules"></v-select>
      </v-col>
      
     </v-row>  

     <v-row no-gutters>
      <v-col class="mx-2" cols="8">
           <v-text-field v-model="hsaf_oms" required label="Description / Name"></v-text-field>
         </v-col>
     </v-row>

      <v-row no-gutters>  
         <v-col class="mx-2" cols="2">
           <v-text-field v-model="hsaf_afstand" label="Distance" ></v-text-field> 
         </v-col>
         <v-col class=mx-0 cols="4">
         <v-select v-model="eenheid" required :items="eenheidKeuzes" item-value="code" item-text="oms" label="Unit" ></v-select>
         </v-col>
      </v-row>    

    
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addHsaf" :disabled="!addHsafValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

export default {
  data() { 
    return {
      dialog: false,
      addHsafValid: false,
      huis_encrid: null,
      afst_nrKeuzes: [],
      hsaf: {},
      hsaf_oms: '',
      hsaf_afstand: 0,
      eenheid: 'km',
      eenheidKeuzes : [
       { code: "km",
          oms: "Kilometer"},
       {code: "m",
          oms: "Meter"},
       {code: "na",
          oms: "Not applicable"}       
      ],
      afst_nrRules: [
          v => !!v || "A 'Distance to'  is required"
      ],
      hsaf_omsRules: [
          v => !!v || "A description / name value is required"
      ],   
      afst_valRules: [
          v => !!v || "A value is required"
      ] 
    }
  },
  methods: {
    open(huis_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hsaf/getHuisToAddHsaf.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisToAddHsaf"
          },
          getHuisToAddHsaf: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hsaf = res.data.getHuisToAddHsaf;
            res.data.getHuisToAddHsaf.afst_nrKeuzes.forEach(function(afst) {
            deze.afst_nrKeuzes.push(afst); 
           });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addHsaf() { 
      this.$axios
        .post("ares/json/ares/huis/hsaf/addHsaf.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addHsaf"
          },
          addHsaf: {
            huis_encrid: this.hsaf.huis_encrid,
            afst_nr: parseInt(this.hsaf.afst_nr),
            hsaf_oms: this.hsaf_oms,
            hsaf_afstand: parseFloat(this.hsaf_afstand),
            eenheid: this.eenheid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
            if (res.data.addHsaf.color == "success")        
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addHsaf.text,
              color: res.data.addHsaf.color
            }); 
            this.$emit('updateData'); 
            this.dialog = false;
          }
        })
    }
  }
}
</script>

